import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["innerHTML"]
const _hoisted_2 = /*#__PURE__*/_createElementVNode("br", null, null, -1)

import { computed, onMounted, ref } from "vue";
import { CmsDocument, CmsTextExcerpt } from "../../services/cms/cms-type-definitions";
import cms from "../../services/cms/cms";


export default /*#__PURE__*/_defineComponent({
  __name: 'cms-excerpt',
  props: {
    slice: {}
  },
  setup(__props: any) {

const props = __props;

const doc = ref<CmsDocument | null>(null);

const loadDocument = async () => {
  if (props.slice) {
    const documentData = await cms.getById(
      props.slice.primary.document.type,
      props.slice.primary.document.id,
    );
    doc.value = documentData;
  }
};

const excerpt = computed(() => {
  if (doc.value && props.slice) {
    if (!props.slice.primary.field_name) {
      return `<p style='color:red'>MISSING FIELD NAME ${doc.value.id} -> ${props.slice.primary.document.id}</p>`;
    }
    const field_name = props.slice.primary.field_name.split(".").slice(-1)[0];
    const docExcerpt = doc.value.data[field_name];

    if (docExcerpt) {
      return cms.asHtml(docExcerpt);
    }
    return `<p style='color:red'>MISSING EXCERPT ${doc.value.id} -> ${props.slice.primary.document.id}</p>`;
  }
  return "";
});

onMounted(() => {
  loadDocument();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", {
      class: "cms-text-excerpt",
      innerHTML: excerpt.value
    }, null, 8, _hoisted_1),
    _hoisted_2
  ]))
}
}

})